import React, { useState, useEffect } from 'react'
import classnames from 'classnames'

import ExpandableTextarea from 'shared/components/community/components/ExpandableTextarea'
import Button from 'shared/components/community/components/button/Button'
import Avatar from 'shared/components/community/components/avatar/Avatar'

import { withStores } from 'utils/helpers.utils'

import { notify } from 'libs/common/notify'

import './community-comment-form.scss'

const CommentForm = (props) => {
  const {
    communityPostsStore,
    communityMemberStore,
    communityId,
    postId,
    comment,
    setEditCommentMode,
    toggleShowCreateCommentForm,
  } = props
  const { id: commentId } = comment || {}
  const { item: member } = communityMemberStore
  const { avatar = [], username } = member || {}

  const [content, setContent] = useState('')
  const [isFocused, setIsFocused] = useState(false)

  useEffect(() => {
    if (comment) {
      setContent(comment.content)
      setIsFocused(true)
    }
  }, [])

  const clearForm = () => {
    setContent('')
    setIsFocused(false)
    if (!commentId) {
      toggleShowCreateCommentForm()
    }
  }

  const isExpanded = isFocused || !!content

  const formContainerClassNames = classnames('community-comment-form__input-container', {
    'community-comment-form__input-container--expanded': isExpanded,
  })

  const avatarUrl = avatar[0]?.cropped || avatar[0]?.original

  const handleCommentSave = async () => {
    const reqData = {
      communityId,
      postId,
      content,
    }

    const submitAction = () =>
      commentId
        ? communityPostsStore.updateComment(commentId, reqData, { skipErrorNotific: true })
        : communityPostsStore.createComment(reqData, { skipErrorNotific: true })

    const resp = await submitAction()

    if (commentId) {
      toggleShowCreateCommentForm()
    }

    const { success, errorCode } = resp || {}

    if (!success && errorCode === 'muted') {
      notify('error', I18n.t('react.shared.community.notific.muted_payer'))
    }

    if (commentId) {
      setEditCommentMode(false)
    }
    clearForm()
  }

  const commentFormClasses = classnames('community-comment-form', {
    'community-comment-form--bottom-border': commentId,
    'community-comment-form--expanded-mobile': isExpanded,
  })
  const buttonDisabled = !content.trim().length

  return (
    <div className={commentFormClasses}>
      <div className='community-comment-form__image-container'>
        <Avatar imageUrl={avatarUrl} />
        {isExpanded && <div className='community-comment-form__username'>{username}</div>}
      </div>
      <div className={formContainerClassNames}>
        <ExpandableTextarea
          className='community-comment-form__textarea'
          onFocus={() => setIsFocused(true)}
          placeholder={I18n.t('react.cabinet.community.post_textarea_field_placeholder')}
          value={content}
          onChange={(e) => setContent(e.target.value)}
          minRows={isExpanded ? 2 : 1}
        />
        <div className='community-comment-form__footer'>
          <div className='community-comment-form__buttons'>
            <Button
              className='community_button--no-border'
              onClick={commentId ? () => setEditCommentMode(false) : clearForm}
            >
              {I18n.t('shared.common.cancel')}
            </Button>
            <Button onClick={handleCommentSave} disabled={buttonDisabled}>
              {I18n.t('react.shared.button.submit_comment')}
            </Button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default withStores(['communityPostsStore', 'communityMemberStore'], CommentForm)
